import React, { useEffect, useRef, useState } from "react"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import {
  searchFinanceVoucherMaster,
  updateCatStatus,
} from "../../../services/finance/finance"
import FinanceFilter from "../filter"
import { capitalize } from "lodash"
import { useLocation } from "react-router-dom"
import EditVoucherMaster from "./edit"

const VoucherMasterIndex = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Finance Voucher Type${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const locations = useLocation()
  const crumb = locations?.state?.menuLabel || ""

  const [page, setPage] = useState("")

  const [series, setSeries] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [count, setCount] = useState(0)
  const [editSeries, setEditSeries] = useState({ modal: false, value: "" })
  const [catFil, setCatFil] = useState("")
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const response = await searchFinanceVoucherMaster({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${
          search ? `&searchText=${search}` : "&searchText"
        }${`&sortOrder=asc`}${page ? `&page=${page}` : ""}${
          catFil ? `&type=${catFil}` : ""
        }${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setSeries(response)
      const newData = response?.data?.data || []

      setSeries(prev =>
        page > 1 && prev
          ? {
              ...response,
              data: {
                ...response.data,
                data: [...(prev.data?.data || []), ...newData],
              },
            }
          : response
      )
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false
    }
    fetchData()
  }, [count, status, search, page, catFil, dataPerPage])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false)
  const scrollTimeoutRef = useRef(null)

  useEffect(() => {
    const handleScroll = e => {
      const { scrollTop, scrollHeight, clientHeight } = e.target

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }

      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < series?.data?.last_page
        ) {
          isLoadingRef.current = true
          setIsLoadingNextPage(true)
          setPage(prev => prev + 1)
        }
      }, 200)
    }

    const container = tableContainerRef.current
    if (container) {
      container.addEventListener("scroll", handleScroll)
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll)
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }
    }
  }, [series, page])

  const handleEdit = item => {
    setEditSeries({ value: item, modal: true })
  }

  const handleStatus = async id => {
    try {
      const response = await updateCatStatus(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const columns = [
    {
      label: "Voucher Name",
      renderCell: item => (
        <div>
          <div className="capitalize-letter">
            {item?.voucher_type ? capitalize(item?.voucher_type) : "-"}
          </div>
        </div>
      ),
    },
    {
      label: "Voucher Type",
      renderCell: item =>
        item?.parent_id ? capitalize(item?.parent?.voucher_type) : "-",
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          {item?.parent_id != null ? (
            <>
              <div>
                <span id={`PopoverLegacy-${item?.id}`}>
                  <img src={action} alt="" className="pointer" />
                </span>
              </div>

              <UncontrolledPopover
                placement="bottom"
                target={`PopoverLegacy-${item?.id}`}
                trigger="legacy"
              >
                <PopoverBody>
                  {/* {loggedUser?.permission?.some(
                permissionItem => permissionItem?.name === "groups_edit"
              ) && item?.parent_id != null ? ( */}
                  {item?.parent_id != null ? (
                    <div
                      className="table-popup-content"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </div>
                  ) : (
                    <></>
                  )}
                  {/* ) : <></>} */}
                </PopoverBody>
              </UncontrolledPopover>
            </>
          ) : (
            <></>
          )}
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleUpdate = () => {
    setCount(count + 1)
  }

  const handleResetValue = () => {
    setEditSeries("")
  }

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleCategoryChange = data => {
    setCatFil(data)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Finance"
              breadcrumbObject={[
                { title: "Finance", link: "/finance" },
                { title: crumb || "Master", link: "/finance" },
                {
                  title: "Voucher Types",
                  link: "/finance/voucher-master",
                },
              ]}
            />
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "groups_create"
            ) && (
              <EditVoucherMaster
                key={"x"}
                onUpdate={handleUpdate}
                onReset={handleResetValue}
                buttonLabel="+&nbsp; Voucher Type"
                className="px-2 mb-3 me-2 btn btn-primary"
                editItem={editSeries}
              />
            )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <FinanceFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleCategoryChange={handleCategoryChange}
              sampleUrl={"download/series.xlsx"}
              importUrl={"finance-sub-cat/import"}
              showExport={
                loggedUser?.permission?.some(
                  permissionItem =>
                    permissionItem?.name === "financesub-category_create"
                )
                  ? true
                  : false
              }
              //   isCat={true}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                <div
                  ref={tableContainerRef}
                  style={{ maxHeight: "490px", overflowY: "auto" }}
                >
                  {series?.data?.data && (
                    <UpdateTable
                      className="mt-5"
                      nodes={series?.data?.data}
                      paginate={series?.data}
                      CurrentPage={page}
                      columns={columns}
                      handlePagination={handlePaginate}
                      handleSizePerPage={handleSizePerPageChange}
                      tableWidth="45% 45% 10%"
                      mobileWidth="40% 40% 20%"
                      isLoading={isLoadingNextPage}
                      hidePaginate={true}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default VoucherMasterIndex
